<template>
  <PokerTableSkeleton
    :players="l_players"
    class="table-street-filter tratablstreet"
  >
    <template #center>
      <PokerPot
        :useNext="useNextPot"
        :spot="l_spot"
        :isVisible="potVisible"
        :hasPot="hasPot"
        :hasStartPot="hasStartPot"
      >
        <PokerBoard
          :useNext="useNextBoard"
          :style="'--height: 5em'"
          :cardRowClass="'card-row_btn'"
          :customAnimation="'anim-card-none'"
          :spot="l_spot"
          @click="openBoardDialog"
        />
      </PokerPot>
    </template>
    <template
      v-for="player in l_players"
      #[player.position]
      :key="player.position"
    >
      <slot :name="`${player.position}_before`" />
      <PokerPlayer
        :player="player"
        :useNext="useNextPlayer"
        :asCheckbox="true"
        :hasStack="playerHasStack"
        :class="playerCssClass || ''"
        v-bind="playersProps"
        @click="$emit('click:player', player)"
      >
        <template #[player.position]>
          <slot :name="player.position" />
        </template>
      </PokerPlayer>
    </template>
  </PokerTableSkeleton>
</template>

<script>
import PokerTableSkeleton from '@/components/PokerTable/PokerTableSkeleton'
import PokerPlayer from '@/components/PokerTable/PokerPlayer'
import { getPlayersDefault } from '@/store/gamestate/gamestate'
import PokerBoard from '@/components/PokerTable/PokerBoard'
import PokerPot from '@/components/PokerTable/PokerPot'

export default {
  name: 'PokerTableStreetFilter',
  components: {
    PokerPlayer,
    PokerBoard,
    PokerPot,
    PokerTableSkeleton,
  },
  props: {
    spot: Object,
    players: Array,
    playerCssClass: String,
    playersProps: { default: () => ({}) },
    namespace: { String, required: true },
    playerHasStack: Boolean,
    gameformat: Object,
  },
  emits: ['click:player'],
  methods: {
    openBoardDialog() {
      const tmpNamespace = 'tmp/primary'
      const cpParams = {
        from_namespace: this.namespace,
        to_namespace: tmpNamespace,
        queryGroup: 'board-filter',
      }
      this.$store.dispatch('poker_copy_module', cpParams)
      const tab = 'flop'
      let dialog = 'practice-filter-dialog'
      dialog = `${dialog}_tab-${tab}_namespace-${this.namespace}_tmpNamespace-${tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
  computed: {
    l_positions() {
      const res = this.l_players.map(i => i.position)
      return res
    },
    useNextPot() {
      return this.l_spot?.useNextPot
    },
    useNextBoard() {
      return this.l_spot?.useNextBoard
    },
    useNextPlayer() {
      return this.l_spot?.useNextPlayer
    },
    l_spot() {
      return this.spot || null
    },
    potVisible() {
      return this.l_spot?.potVisible
    },
    hasPot() {
      return this.l_spot?.hasPot
    },
    hasStartPot() {
      return this.l_spot?.hasStartPot
    },
    l_players() {
      if (this.players?.length) {
        return this.players
      }
      return getPlayersDefault({ gameformat: this.gameformat })
    },
    devPlayers() {
      // return [...new Array(2).keys()]
      // return [...new Array(3).keys()]
      // return [...new Array(4).keys()]
      // return [...new Array(5).keys()]
      // return [...new Array(6).keys()]
      // return [...new Array(7).keys()]
      return (
        [...new Array(8).keys()]
          // return [...new Array(9).keys()]
          .map((i, idx) => ({
            stack: 99,
            // position: 'UTG',
            position: `UTG${idx}`,
            hand: 'AsAs',
            // hand: 'EeEe',

            chips_on_table: 99,
            current_stack: 99,
            next_chips_on_table: 99,
            next_current_stack: 99,
            // is_dealer: true,
            is_folded: false,
            next_is_folded: false,
            is_hero: false,
            is_active: false,
          }))
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.tratablstreet {
  &_table-name {
    color: var(--clr-white-0);
    color: var(--clr-primary);
    font-weight: 700;
    min-height: 0;
    height: 0;
    position: relative;
    top: -0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &_icon {
    --icon-clr: var(--clr-primary);
    position: absolute;
    top: 100%;
    transform: translate(0, -68%);
    z-index: 1;
    color: va(--icon-clr);
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
